import { useState } from "react"

const PlanChangeStorageKey = {
  UpdateNotification: `showPlanUpdateNotification`,
  ChangeRequest: `changePlanTo`,
}

/**
 * We separately manage showing Plan change / Plan change request Notification component, which is showed just after the successful action
 * and can be dismissed by user and Plan change request note in footer of PlanInformation, which can't be dismissed and
 * is presented till the moment Plan change request is fulfilled by Sales
 */
export default function usePlanChangeState(organizationId) {
  const isBrowser = typeof window !== `undefined`

  const updateNotificationKey = `${PlanChangeStorageKey.UpdateNotification}:${organizationId}`

  const changeRequestKey = `${PlanChangeStorageKey.ChangeRequest}:${organizationId}`

  const planUpdateNotificationVisibleInitValue =
    isBrowser && window.sessionStorage.getItem(updateNotificationKey)
      ? true
      : false

  const [
    planUpdateNotificationVisible,
    setPlanUpdateNotificationVisible,
  ] = useState(planUpdateNotificationVisibleInitValue)

  const requestedPlanName = isBrowser
    ? window.localStorage.getItem(changeRequestKey)
    : ``

  function enablePlanUpdateNotification() {
    window.sessionStorage.setItem(updateNotificationKey, `1`)
  }

  function disablePlanUpdateNotification() {
    window.sessionStorage.removeItem(updateNotificationKey)
  }

  function hidePlanUpdateNotification() {
    setPlanUpdateNotificationVisible(false)
    disablePlanUpdateNotification()
  }

  function storePlanChangeRequest(planName) {
    enablePlanUpdateNotification()
    window.localStorage.setItem(changeRequestKey, planName)
  }

  function clearPlanChangeRequest() {
    setPlanUpdateNotificationVisible(false)
    window.sessionStorage.removeItem(updateNotificationKey)
    window.localStorage.removeItem(changeRequestKey)
  }

  return {
    planUpdateNotificationVisible,
    enablePlanUpdateNotification,
    hidePlanUpdateNotification,
    requestedPlanName,
    storePlanChangeRequest,
    clearPlanChangeRequest,
  }
}
